import { render } from "./DeepSeaResponse.vue?vue&type=template&id=2d654497&scoped=true"
import script from "./DeepSeaResponse.vue?vue&type=script&lang=js"
export * from "./DeepSeaResponse.vue?vue&type=script&lang=js"

import "./DeepSeaResponse.vue?vue&type=style&index=0&id=2d654497&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d654497"]])

export default __exports__